import { Factory } from "fishery";
import { LineItemType, AddToBasketPayloadType } from "@/app/types/line-items";
import { Product } from "@/app/types/product";
import { CountryCode } from "@/app/types/country-types";
import { ComboChoiceForOrder, OrderLinesWithOptions } from "@/app/types/option";

const defaultProduct: Product = {
  id: 1,
  name: "10 Piece Chicken Nuggets",
  description: "Served with butter and salt",
  calories: 400,
  price: 700,
  filterCategories: [],
  filterOrder: 1,
  imageUrl: "",
  nutritionalInformation: [],
  options: null,
  variations: [],
  schedule: [],
  oneTimeSchedule: null,
  countryCode: "SA" as CountryCode,
  countryCodes: ["SA" as CountryCode],
  allergenInformation: {
    egg: "",
    fish: "",
    milk: "",
    mustard: "",
    sesame: "",
    crustaceans: "",
    soy: "",
    gluten: "",
  },
  inStock: true,
};

export { defaultProduct };

export const productFactory = Factory.define<Product>(({ sequence }) => ({
  ...defaultProduct,
  id: sequence,
}));

export const lineItemFactory = Factory.define<
  LineItemType,
  any,
  LineItemType,
  Partial<LineItemType>
>(({ sequence, params }) => ({
  id: sequence,
  productId: 1,
  quantity: 1,
  ...(params as Partial<LineItemType>),
}));

export const createAddToBasketPayload = (
  overrides: Partial<AddToBasketPayloadType> = {},
): AddToBasketPayloadType => ({
  item: defaultProduct,
  quantity: 20,
  ...overrides,
});

export const createEditBasketPayload = (
  overrides: Partial<{
    lineId: string;
    item: Product;
    variationId?: number;
    quantity: number;
  }> = {},
) => ({
  lineId: "1",
  item: defaultProduct,
  quantity: 10,
  ...overrides,
});

export const createDeleteBasketPayload = (
  overrides: Partial<{
    lineId: string;
  }> = {},
) => ({
  lineId: "1",
  ...overrides,
});

export const comboChoiceFactory = Factory.define<ComboChoiceForOrder>(
  ({ params }) => ({
    productId: 201,
    quantity: 1,
    isUpselling: false,
    ...params,
  }),
);

export const orderLineFactory = Factory.define<OrderLinesWithOptions>(
  ({ sequence, params }) => ({
    productId: sequence,
    quantity: 1,
    ...params,
  }),
);
